/**
 * MEWS Connector API base — ONE source of truth.
 *
 * This is a VIRTUAL sentinel prefix, never fetched directly. Every caller builds
 * `${MEWS_CONNECTOR_BASE}/<endpoint>` and hands it to `proxy()` (see
 * `utils/proxy.ts`), which matches this exact prefix to route the call through
 * the backend MEWS proxy and strip it to the bare endpoint path. Because the
 * match is a string prefix, the value MUST be byte-identical at every call site
 * — which is why it used to be copy-pasted into ~20 files. Centralising it here
 * makes that guarantee structural instead of a convention nobody can enforce.
 *
 * Kept env-overridable the same way the other MEWS config is (see
 * `utils/mewsUrl.ts`): set `VITE_MEWS_CONNECTOR_BASE` to override the default.
 */
const RAW = import.meta.env.VITE_MEWS_CONNECTOR_BASE

/** Treat an unsubstituted `__VITE_x__` placeholder as absent. */
function isPlaceholder(v: string | undefined): boolean {
  return !!v && v.startsWith('__VITE_') && v.endsWith('__')
}

export const MEWS_CONNECTOR_BASE: string =
  RAW && !isPlaceholder(RAW) ? RAW : 'https://mews-proxy.internal/api/connector/v1'
